export const BUYER_DIGEST = 'buyer-digest'
export const NEST_READY_HOME_SEARCH = 'nest-ready-home-search'
